export interface RequestGetPostDto {
	page?: number;
	limit: number;
	empId: string;
	skip: number
}
export interface RequestGetFollowingDto {
	page: number;
	limit: number;
	empId: string;
}

export interface RequestGetFollowerDto {
	page: number;
	limit: number;
	empId: string;
}


export interface RequestSetPostDto {
	content: string;
	picture: string;
	flagAchievement: boolean;
	sharedEmp?: any;
	attachment: any[];
	taskCode?: any;
}

export interface RequestSetStatusPostDto {
	postId: number;
	flag: string;
}

export interface RequestGetLikeDto {
	postId: number;
	page: number;
	limit: number;
}

export interface RequestSetLikeDto {
	postId: number;
	status: boolean;
}

export interface RequestSetCommentDto {
	postId: number;
	content: string;
}

export interface RequestSetFollowDto {
	status: string;
	empId: string;
}

export class RequestUnfollowDto {
  empId: string;
}

export interface ResponseGetFollowing {
	page: number;
	limit: number;
	total: number;
	totalPage: number;
	data: Datum[];
}
export interface ResponseGetFollower {
	page: number;
	limit: number;
	total: number;
	totalPage: number;
	data: Datum[];
	message: any;
}

export interface Datum {
	id: number;
	followerId: string;
	companyId: string;
	companyCode: string;
	empId: string;
	status: number;
	createdBy: string;
	createdDate: string;
	modifiedBy: string;
	modifiedDate: string;
	relFollowing: RelFollowing;
}

export interface RelFollowing {
	userId: number;
	fullName: string;
	empId: string;
	posNameEn: string;
	photo: string;
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/dto/post-service.dto.ts